import type { BrewerModel } from './brewers.types';
import type { UserModel } from './users.types';
import type { VenueModel } from './venues.types';

export enum ClientStatusType {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export enum SegmentType {
  NationalBrewerWholesaler = 'National Brewer / Wholesaler',
  RegionalBrewerWholesaler = 'Regional Brewer / Wholesaler',
  NationalPubCompany = 'National Pub Company',
  MultipleRetailGroup = 'Multiple Retail Group',
  HotelGroup = 'Hotel Group',
  HolidayParksLeisureResorts = 'Holiday Parks / Leisure Resorts',
  Independents = 'Independents',
  Stadia = 'Stadia',
  Other = 'Other'
}

export type ClientSortingFields =
  | 'name'
  | 'status'
  | 'segment'
  | 'brewerName'
  | 'venuesCount'
  | 'barsCount'
  | 'contactsCount';

export interface ClientModel {
  id: string;
  users: UserModel[];
  leadBrewer?: BrewerModel;
  name: string;
  description: string | null;
  externalId: string | null;
  segment: SegmentType | null;
  status: ClientStatusType;
  contractTerm?: string;
  venues: VenueModel[];
}

export type ListClientModel = Pick<ClientModel, 'id' | 'name' | 'status' | 'segment'> & {
  brewerName?: string;
  venuesCount: number;
  barsCount: number;
  contactsCount: number;
};

export interface ListClientsResponse {
  result: ListClientModel[];
  limit: number;
  offset: number;
  count: number;
}

export interface CreateClientParams {
  name: string;
  leadBrewerId?: string;
  users: string[];
  status: ClientStatusType;
  contractTerm?: string | null;
  externalId?: string;
  description?: string;
  segment: SegmentType | null;
}

export interface UpdateClientParams {
  name: string;
  leadBrewerId?: string;
  users: string[];
  status: ClientStatusType;
  contractTerm?: string | null;
  externalId?: string | null;
  description?: string | null;
  segment?: SegmentType | null;
}

export interface UpdateClientParamsWithId extends UpdateClientParams {
  clientId: string;
}

export interface DeleteClientParams {
  clientId: string;
}

export interface ListAutoCompleteClientsResponse {
  result: ClientModel[];
  count: number;
}

export interface ClientsFiltersProps {
  name?: string;
  segment?: SegmentType;
  status?: ClientStatusType;
  leadBrewerName?: string;
}
